/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Registration_Toggle_LabelInputs */

const en_admin_company_registration_toggle_label = /** @type {(inputs: Admin_Company_Registration_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company registration open`)
};

const de_admin_company_registration_toggle_label = /** @type {(inputs: Admin_Company_Registration_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung für Unternehmen geöffnet`)
};

/**
* | output |
* | --- |
* | "Company registration open" |
*
* @param {Admin_Company_Registration_Toggle_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_registration_toggle_label = /** @type {((inputs?: Admin_Company_Registration_Toggle_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Registration_Toggle_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_registration_toggle_label(inputs)
	return en_admin_company_registration_toggle_label(inputs)
});